/**
 * Утилита для форматирования текста уведомлений
 */

import type { Notification, NotificationType } from '../model';

/** Типы уведомлений, связанных с Тайным Сантой */
const SECRET_SANTA_TYPES: ReadonlySet<NotificationType> = new Set([
  'secret_santa_invite',
  'secret_santa_accepted',
  'secret_santa_declined',
  'secret_santa_draw_complete',
]);

/** Типы уведомлений, связанных с соавторством */
const COLLABORATOR_TYPES: ReadonlySet<NotificationType> = new Set([
  'collaborator_invite',
  'collaborator_invite_accepted',
  'collaborator_invite_declined',
]);

/** Возвращает i18n-ключ для текста уведомления по его типу */
export function getNotificationTypeKey(type: NotificationType): string {
  return `notifications:notification.types.${type}`;
}

/** Возвращает URL изображения для уведомления (подарок или обложка вишлиста) */
export function getNotificationImage(notification: Notification): string | undefined {
  // Изображение подарка (бронирование)
  if (notification.wish?.imageUrl) {
    return notification.wish.imageUrl;
  }

  return undefined;
}

/** Возвращает заголовок-описание уведомления (название подарка, вишлиста или игры) */
export function getNotificationTitle(notification: Notification): string | undefined {
  // Название подарка
  if (notification.wish?.title) {
    return notification.wish.title;
  }

  // Название вишлиста
  if (notification.wishlist?.title) {
    return notification.wishlist.title;
  }

  // Название игры Тайный Санта
  if (notification.secretSantaGame?.name) {
    return notification.secretSantaGame.name;
  }

  return undefined;
}

/** Проверяет, является ли уведомление приглашением в Тайный Санта */
export function isSecretSantaInvite(notification: Notification): boolean {
  return notification.type === 'secret_santa_invite';
}

/** Проверяет, связано ли уведомление с Тайным Сантой */
export function isSecretSantaRelated(notification: Notification): boolean {
  return SECRET_SANTA_TYPES.has(notification.type);
}

/** Проверяет, является ли уведомление приглашением стать соавтором */
export function isCollaboratorInvite(notification: Notification): boolean {
  return notification.type === 'collaborator_invite';
}

/** Проверяет, связано ли уведомление с соавторством */
export function isCollaboratorRelated(notification: Notification): boolean {
  return COLLABORATOR_TYPES.has(notification.type);
}